module.exports = __webpack_public_path__ + "static/media/logo_mass.10d99c61.png";